export default __webpack_public_path__ + "static/media/2014.e8e82bb5.png";